export interface StPaymentsDeps {
  isTelegramMiniApp: Ref<boolean>
  isUserSettingsSet: ComputedRef<boolean>
  updateUserPreferredCurrencyCode: (currencyCode: string) => Promise<void>
}

export const [usePaymentsDeps, providePaymentsDeps] =
  createEntityDeps<StPaymentsDeps>('payments')
